<template>
  <AppBtn v-if="edit" icon="edit" color="primary" />
</template>

<script setup>
import AppBtn from "./AppBtn.vue";
import { computed, getCurrentInstance } from "vue";

const instance = getCurrentInstance();
const formParent = instance.parent;
const appFormParent = formParent.parent;
const edit = computed(() => appFormParent.parent.exposed?.isNew?.value || true);
</script>